export const PAYMENT_TRACKER_TYPE_WEB_CLIENT_INIT = 0;

export const PAYMENT_TRACKER_PLATFORM_WEB = 0;
